import { ComingSoon } from "components/common/ComingSoon"

import { AccountPageShell } from "./shared"

export const ComingSoonPage = () => (
  <AccountPageShell>
    <ComingSoon />
  </AccountPageShell>
)
